module.exports = __webpack_public_path__ + "img/user-avatar.c6973335.svg";